import React from 'react';

const ArrowDown = () => (
    <svg id="faq-button-svg" width="22px" height="12px" viewBox="0 0 22 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g transform="translate(-1203.000000, -618.000000)">
            <path className="path" d="M1222.17532,618.463174 C1222.82255,617.845609 1223.86826,617.845609 1224.51548,618.463174 C1225.1603,619.08074 1225.16271,620.080497 1224.51548,620.700393 L1215.17174,629.535078 C1214.52451,630.154974 1213.47639,630.154974 1212.82916,629.535078 L1203.48542,620.700393 C1202.83819,620.080497 1202.83819,619.08074 1203.48542,618.463174 C1204.13265,617.845609 1205.17836,617.845609 1205.82558,618.463174 L1214.00045,625.708501 L1222.17532,618.463174 L1222.17532,618.463174 Z"></path>
        </g>
    </svg>
);

export default ArrowDown;


// WEBPACK FOOTER //
// ./src/resources/icons/arrow-down.jsx